import { combineReducers } from "redux";

// Front
import Layout from "./layouts/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

//Client
import Client from "./client/reducer";
//Admin
import Admin from "./admin/reducer";
//Chauffeur
import Chauffeur from "./chauffeur/reducer";
// Organisateur
import Organisateur from "./organisateur/reducer";
// Paie des Organisateurs
import PayOrganizer from "./pay-organizer/reducer";
// Evenement
import Evenement from "./evenement/reducer";
//Livreur
import Livreur from "./livreur/reducer";
//Code promo
import CodePromo from "./code-promo/reducer";
//Parainage
import Parainage from "./parainage/reducer";

// Alertes
import Alerte from "./alertes/reducer";
import Historique from "./historique/reducer";
import Facture from "./facture/reducer";
import Majoration from "./majoration/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  Client,
  Admin,
  Chauffeur,
  Livreur,
  Organisateur,
  PayOrganizer,
  Historique,
  Evenement,
  CodePromo,
  Parainage,
  Alerte,
  Facture,
  Majoration,
});

export default rootReducer;
